import Proxy from './Proxy';
import  axios from 'axios';

class MosaicProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/mosaic', parameters);
  }

  get_mosaics() {
    return this.submit('get', `${this.endpoint}/mosaicListByNamespace?ns=${process.env.VUE_APP_TOKEN_NAMESPACE}`);
  }

  async get_info() {
    return await axios({
      method:'get',
      url:'info.json',
      baseURL: '/',
    })
  }

  mosaic_tx_count(namespace) {
    return this.submit('get', `${this.endpoint}/txCount?ns=${namespace}`);
  }


  get_mosaic_detail(namespace) {
    this.set_data({
      m: namespace,
      ns:process.env.VUE_APP_TOKEN_NAMESPACE
    });
    return this.submit('post', `${this.endpoint}/mosaic`);
  }

  get_mosaic_rich_count(namespace) {
    return this.submit('get', `${this.endpoint}/mosaicRichCount?ns=${process.env.VUE_APP_TOKEN_NAMESPACE}&m=${namespace}`);
  }

  get_mosaic_rich_list(namespace, num) {
    this.set_data({
      m: namespace,
      ns: process.env.VUE_APP_TOKEN_NAMESPACE
    });
    if(num) {
      this.data.page = num
    }
    return this.submit('post', `${this.endpoint}/mosaicRichList`);
  }

  get_mosaic_tx_list(namespace, num) {
    this.set_data({
      m: namespace,
      ns: process.env.VUE_APP_TOKEN_NAMESPACE
    });
    if(num) {
      this.data.page = num
    }
    return this.submit('post', `${this.endpoint}/mosaicTransferList`);
  }

  get_mosaic_tx(address, page) {
    this.set_data({address, page});
    return this.submit('post', `account/detailMosaicTXList`);
  }

  get_mosaic_count(address) {
    this.set_data({address});
    return this.submit('post', `account/detailMosaicCount`);
  }




}

export default MosaicProxy;
